'use strict';

module.exports = function () {
    $('.container').on('click', '#sort-order-list li', function (e) {
        e.stopPropagation();
        e.preventDefault();

        var optionID = $(this).data('id');

        $('#sort-order-select > option').attr('selected', false);

        $('#sort-order-select > option.' + optionID + '').attr('selected', true);
        $('#sort-order-select > option.' + optionID + '').trigger('change');
    });
};
